import { SearchInput } from "components/Atoms/SearchInput";
import React, { useContext, useEffect } from "react";
import { Button } from "semantic-ui-react";
import { FilterContext } from "../FilterContext";
import { areEqual } from "../FilterGroups/instructionUtils";
import FilterPopup from "../FilterPopup";
import { initialKeywordFilter } from "./FilterTypes/KeywordFilterType";

interface Props {
  placeholder: string
  initialQuery?: string
  label?: string
  title?: string
}

const KeywordFilter = (props: Props) => {
  const label = props.label || RESX.GeneralLabels.Keyword;
  const title = props.title || RESX.GeneralLabels.Keyword;

  const initialValue = { ...initialKeywordFilter, query: props.initialQuery ?? "" };

  const { register, getValue, setInitialValue, setValue } = useContext(FilterContext);
  register("keyword", {
    getTitle: () => title,
    renderSelection: (keyword) => <>{keyword.query}</>,
    hasValue: (keyword) => keyword.query != null && keyword.query.trim().length > 0,
    reset: () => initialKeywordFilter,
    areEqual: (a, b) => areEqual(a.query, b.query, "")
  });
  useEffect(() => {
    setInitialValue("keyword", initialValue);
  }, []);

  const [searchQuery, setSearchQuery] = React.useState<string>(initialValue.query);
  const [popupOpen, setPopupOpen] = React.useState<boolean>(false);

  const onQueryChange = (value) => {
    setSearchQuery(value);
  };

  const onPopupClose = () => {
    onSubmit();
  };

  // We want to re-set the search query value from context
  // Because it could have changed in some other way
  const onPopupOpen = () => {
    setSearchQuery(getValue("keyword").query ?? "");
    setPopupOpen(true);
  };

  const onKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      onPopupClose();
    }
  };

  const onSubmit = (e?) => {
    e?.preventDefault();
    setValue("keyword", { query: searchQuery });
    setPopupOpen(false);
  };

  return <div>
    <FilterPopup
      filterButtonLabel={label}
      content={<>
        <div className="margin-bottom">
          <SearchInput
            onKeyDown={onKeyDown}
            onChange={value => { onQueryChange(value); }}
            value={searchQuery}
            placeholder={props.placeholder}
            focusOnMount
          />
        </div>
        <Button primary onClick={onSubmit} fluid>
          {RESX.SelectionManager.Apply}
        </Button>
      </>}
      width={272}
      open={popupOpen}
      onClose={onPopupClose}
      onOpen={onPopupOpen}
    />
  </div>;
};

export default KeywordFilter;
